module.exports = __webpack_public_path__ + "img/locked-padlock.6fabc71.svg";